import { MessageOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { CustomValidationRuleContent } from './CustomValidationRuleContent.tsx';

const CenterButtonWrapper = styled.div<ICustomValidationRuleMessageProps>`
  display: inline-block;
  margin-top: ${props => (props.marginFormItem ? 8 : 0)}px;
  margin-bottom: ${props => (props.marginFormItem ? 24 : 0)}px;
`;

export interface ICustomValidationRuleMessageProps {
  name: string;
  isGhostType?: boolean;
  marginFormItem?: boolean;
}

/**
 * Button con popover per impostare il messaggio personalizzato per le regole di validazione
 */
export function CustomValidationRuleMessage(
  props: ICustomValidationRuleMessageProps,
) {
  const { name, isGhostType } = props;
  const customMessage = useWatch({ name });
  const [visible, setVisible] = useState(false);
  const type = customMessage ? 'primary' : 'default';

  return (
    <Popover
      open={visible}
      onOpenChange={open => {
        setVisible(!!open);
      }}
      title={'Messaggio di errore personalizzato:'}
      content={
        <CustomValidationRuleContent name={name} setVisible={setVisible} />
      }
      trigger="click"
    >
      <CenterButtonWrapper {...props}>
        <Button
          shape="circle"
          type={type}
          ghost={isGhostType}
          icon={<MessageOutlined style={{ fontSize: '16px' }} />}
        />
      </CenterButtonWrapper>
    </Popover>
  );
}
